import { IntlShape, MessageDescriptor } from "react-intl";

export const getLocalizedMessage = (key: string, descriptor: MessageDescriptor | undefined, intl: IntlShape): string => {
	if (descriptor === undefined) {
		return key;
	}

	return intl.formatMessage(descriptor);
};
